const devConfig = {
  VUE_APP_API_BASE_URL: 'http://localhost:4000/api/v1',
  VUE_APP_HTTP_TIMEOUT: 200000,
  VUE_APP_API_CLIENT_ID: 1,
  VUE_APP_API_CLIENT_SECRET: 'XSBA7kJqvcgZ7WFE3O1b4bmyl0HJ051p19kE1Zez',
  VUE_APP_API_GRANT_TYPE: 'password'
};

const testConfig = {
  VUE_APP_API_BASE_URL: 'http://localhost:4000/api/v1',
  VUE_APP_HTTP_TIMEOUT: 200000,
  VUE_APP_API_CLIENT_ID: 1,
  VUE_APP_API_CLIENT_SECRET: 'XSBA7kJqvcgZ7WFE3O1b4bmyl0HJ051p19kE1Zez',
  VUE_APP_API_GRANT_TYPE: 'password'
};

const prodConfig = {
  VUE_APP_API_BASE_URL: 'https://api.tams.com.ng/api/v1',
  VUE_APP_DOWNLOAD_URL: 'https://api.tams.com.ng/downloads/',
  VUE_APP_HTTP_TIMEOUT: 200000,
  VUE_APP_API_CLIENT_ID: 1,
  VUE_APP_API_CLIENT_SECRET: '41t4MybUKTMhOxB8Glu1xyOvxPPIL0EFU9Pg3135',
  VUE_APP_API_GRANT_TYPE: 'password',
  RAVE_KEY: 'FLWPUBK-189348b8da7e2966ee250ce9488a8cc1-X',
  USE_SUB_DOMAIN: true
};
const NODE_ENV = process.env.NODE_ENV;

export default {
  ...(devConfig && NODE_ENV === 'development' && {...devConfig}),
  ...(testConfig && NODE_ENV === 'test' && {...testConfig}),
  ...(prodConfig && NODE_ENV === 'production' && {...prodConfig})
}
